/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Section_3_Item_AiInputs */

const en_privacy_section_3_item_ai = /** @type {(inputs: Privacy_Section_3_Item_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Providing AI assistance`)
};

const lv_privacy_section_3_item_ai = /** @type {(inputs: Privacy_Section_3_Item_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI palīdzības sniegšana`)
};

/**
* | output |
* | --- |
* | "Providing AI assistance" |
*
* @param {Privacy_Section_3_Item_AiInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const privacy_section_3_item_ai = /** @type {((inputs?: Privacy_Section_3_Item_AiInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Section_3_Item_AiInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_privacy_section_3_item_ai(inputs)
	return en_privacy_section_3_item_ai(inputs)
});